import { ReactNode, Suspense } from "react";
import { ThemeProvider, ThemeProviderScope } from "@kaltura/mediaspace-shared-contexts/ThemeProvider";
import { ToastsProvider } from "@kaltura/mediaspace-shared-contexts/ToastsProvider";
import { Config } from "@kaltura/mediaspace-shared-data-kms-config/Config";
import { ConfigProvider } from "@kaltura/mediaspace-shared-data-kms-config/ConfigContext";
import { SessionActivityProvider } from "@kaltura/mediaspace-shared-session-activity";

export type TopLevelComponentWrappersProps = ThemeProviderScope & {
    children: ReactNode;
    context: Config;
};

/**
 * Common contexts and other wrappers for a top-level component.
 */
export const TopLevelComponentWrappers = ({ children, context, ...scopeProps }: TopLevelComponentWrappersProps) => {
    const { theming } = context;

    return (
        <Suspense fallback={<div />}>
            <ConfigProvider context={context}>
                <ThemeProvider {...scopeProps} overrides={theming?.theme} mode={theming?.mode}>
                    <ToastsProvider toastDuration={4000}>
                        <SessionActivityProvider>{children}</SessionActivityProvider>
                    </ToastsProvider>
                </ThemeProvider>
            </ConfigProvider>
        </Suspense>
    );
};
